import { createSelector } from 'reselect';
import { getIsMachineManualPartCount } from './getIsMachineManualPartCount';
import { getManualPartCountManagement } from './getManualPartCountManagement';
import { getScopeStart } from './getScopeStart';
import { getCurrentLaborTicket } from './getLaborTickets';

/**
 * Selector that returns user-added manual part counts filtered by scope and labor ticket timing.
 * Used by useManualPartCountCleanup to track parts that haven't been processed by the database yet.
 *
 * @returns {Array} Filtered manual part counts within current scope and labor ticket timeframe
 */
export const getUserAddedManualPartCounts = createSelector(
  [
    getIsMachineManualPartCount,
    getManualPartCountManagement,
    getScopeStart,
    getCurrentLaborTicket,
  ],
  (
    isMachineManualPartCount,
    manualPartCountManagement,
    scopeStart,
    currentLaborTicket
  ) => {
    // Only return parts for manual part count machines
    if (!isMachineManualPartCount) return [];

    const clockIn = currentLaborTicket?.clockIn;
    return (
      manualPartCountManagement?.userAddedManualPartCounts?.filter(
        (partCount) => {
          return (
            // Filter by scope start time
            (!scopeStart ||
              new Date(partCount.partTime) >= new Date(scopeStart)) &&
            // Filter by labor ticket clock in time
            (!clockIn || new Date(partCount.partTime) >= new Date(clockIn))
          );
        }
      ) || []
    );
  }
);
